import { Link, Shimmer, Stack } from "@fluentui/react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";
import { useState } from "react";
import { shimmerWithElementGapRow } from "../../helper/ShimmerElement";
import DomainPanel from "../Domain/DomainPanel";
import {
  containerStyle,
  domainCountContainerStyle,
  IconPositionStyles,
  labelStyles,
  shimmerFlexStyle,
  shimmerLoadStyle,
  shimmerStyle,
  stackTokens,
  titleStyle,
  wordWrapStyle
} from "./CustomerDetails.styles"; // Adjust the import path as necessary

export default function CustomerDetails(props: any) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div style={containerStyle}>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Industry </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.industryName}</div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Vertical </div>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.verticalName}</div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Segment </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.segmentName}</div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Country </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.countryName}</div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Region </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.regionName}</div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={titleStyle}>Sub Segment </div>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              style={shimmerFlexStyle}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={wordWrapStyle}>:&nbsp;{props.custDetails?.subSegmentName}</div>
            </Stack>
          )}
        </Stack>
      </div>
      <Divider orientation="vertical" flexItem style={{ marginBottom: "20px" }} />
      <div style={domainCountContainerStyle}>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>isS500</div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerLoadStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div title={props.custDetails?.isS500 ? "S500" : "No S500"} style={IconPositionStyles}>
                :&nbsp;{" "}
                {props.custDetails?.isS500 === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>HasPartner </div>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              style={{
                marginTop: 10,
                width: 95,
                paddingLeft: 4,
                paddingRight: 3
              }}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div title={props.custDetails?.hasPartner ? "Has a partner" : "No partner"} style={IconPositionStyles}>
                :&nbsp;{" "}
                {props.custDetails?.hasPartner === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>isFasttrack </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={{
                marginTop: 10,
                width: 95,
                paddingLeft: 4,
                paddingRight: 3
              }}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div
                title={props.custDetails?.isFasttrackTenant ? "Fast Track tenant" : "No Fast Track tenant"}
                style={IconPositionStyles}
              >
                :&nbsp;{" "}
                {props.custDetails?.isFasttrackTenant === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack>
        {/* <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "95px" }}>isTCT </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerLoadStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div title={props.custDetails?.isSST ? "SST" : "No SST"} style={IconPositionStyles}>
                :&nbsp;{" "}
                {props.custDetails?.isSST === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack> */}
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>isMCS</div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerLoadStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div title={props.custDetails?.isMCS ? "MCS" : "No MCS"} style={IconPositionStyles}>
                :&nbsp;{" "}
                {props.custDetails?.isMCS === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>isSecurityAdvisor</div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerLoadStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div title={props.custDetails?.isCCP ? "CCP" : "No CCP"} style={IconPositionStyles}>
                :&nbsp;{" "}
                {props.custDetails?.isCCP === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                  />
                )}
              </div>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              style={shimmerStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div style={{ width: "100px" }}>Domain Count </div>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              style={shimmerLoadStyle}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <div>
                :&nbsp;&nbsp;
                <Link onClick={() => setIsOpen(true)}>{props.custDetails?.domainCount}</Link>
                <DomainPanel isOpen={isOpen} onDismiss={setIsOpen} tenantName={props.custDetails?.tenantName} />
              </div>
            </Stack>
          )}
        </Stack>
      </div>
    </>
  );
}
